import React from 'react'
import TreeComp from 'components/Tree'
import { FloatButton, TreeProps } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoneAlt, faSignOut, faTableCells } from '@fortawesome/free-solid-svg-icons'
import usePagination from 'hooks/usePagination'
import { IProject } from 'models/Project'
import { IAssetType } from 'models/AssetsTypes'
import { IAsset } from 'models/Assets'
import MapViewHooks from './MapViewHooks'
import DrawerComp from 'components/Drawer'

type Props = {
    hookProjects: ReturnType<typeof usePagination<IProject>>;
    hookAssetsTypes: ReturnType<typeof usePagination<IAssetType>>;
    hookAssets: ReturnType<typeof usePagination<IAsset>>;
    checkedKeys: TreeProps['checkedKeys'];
    setCheckedKeys: (checkedKeys: TreeProps['checkedKeys']) => void;
}

const MapViewOptions: React.FC<Props> = ({
    hookProjects,
    hookAssetsTypes,
    hookAssets,
    checkedKeys,
    setCheckedKeys
}: Props) => {
    const { openListPMV, signOut, openMainSOS } = MapViewHooks();
    return (
        <>
            {/* Filtrar elementos del inventario para visualizar en el mapa */}
            <DrawerComp title='Filtros'>
                <TreeComp
                    hookProjects={hookProjects}
                    hookAssetsTypes={hookAssetsTypes}
                    hookAssets={hookAssets}
                    checkedKeys={checkedKeys}
                    setCheckedKeys={setCheckedKeys}
                />
            </DrawerComp>
            {/* Mostrar vista previa de todos los PMV */}
            <FloatButton
                icon={<FontAwesomeIcon icon={faTableCells} />}
                tooltip={"Paneles de Mensaje Variable"}
                onClick={openListPMV}
                type='primary'
                style={{ marginBottom: '3rem' }}
            />
            {/* Cerrar sesión */}
            <FloatButton
                icon={<FontAwesomeIcon icon={faSignOut} />}
                tooltip={"Cerrar sesión"}
                onClick={signOut}
                type='primary'
                style={{ marginBottom: '6rem' }}
            />
            {/* Eventos y gráficas SOS */}
            <FloatButton
                icon={<FontAwesomeIcon icon={faPhoneAlt} />}
                tooltip={"Eventos y gráficas SOS"}
                onClick={openMainSOS}
                type='primary'
                style={{ marginBottom: '9rem' }}
            />
        </>
    )
}

export default MapViewOptions